/** Canonical wallet Terms & Conditions version — keep in sync with docs/TERMS_AND_CONDITIONS.md */
export const WALLET_TERMS_VERSION = '2.6.0';

/** Section 29 — Short Customer Disclosure for Registration Screen (docs/TERMS_AND_CONDITIONS.md §29) */
export const WALLET_REGISTRATION_DISCLOSURE = {
  title: 'Important Wallet Notice',
  paragraphs: [
    'Your MyMoolah Wallet is a transaction and disbursement interface. It is not a bank account.',
    'Funds in your Wallet are classified as either Own Funds or Third-Party Disbursement Value.',
    'Own Funds are funds you load yourself. Own Funds may be used only for approved non-cash services, such as airtime, data, electricity, bill payments and approved merchant payments. Own Funds cannot be withdrawn as cash.',
    'Third-Party Disbursement Value is value paid to you by an approved third party, such as an employer, lender, benefit provider, insurer or approved business client. Only eligible Third-Party Disbursement Value may be available for cash withdrawal, subject to verification, limits, partner availability and compliance checks.',
  ],
  acceptanceLine: 'By continuing, you accept these rules.',
} as const;
